import { render, staticRenderFns } from "./stage.vue?vue&type=template&id=1c0f6d6e"
import script from "./stage.vue?vue&type=script&lang=js"
export * from "./stage.vue?vue&type=script&lang=js"
import style0 from "./stage.vue?vue&type=style&index=0&id=1c0f6d6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports